/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Currentplan1Inputs */

const zh_subscription_currentplan1 = /** @type {(inputs: Subscription_Currentplan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前计划`)
};

const en_subscription_currentplan1 = /** @type {(inputs: Subscription_Currentplan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Plan`)
};

const es_subscription_currentplan1 = /** @type {(inputs: Subscription_Currentplan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan actual`)
};

/**
* | output |
* | --- |
* | "Current Plan" |
*
* @param {Subscription_Currentplan1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscription_currentplan1 = /** @type {((inputs?: Subscription_Currentplan1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Currentplan1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_currentplan1(inputs)
	if (locale === "en") return en_subscription_currentplan1(inputs)
	return es_subscription_currentplan1(inputs)
});
export { subscription_currentplan1 as "subscription_currentPlan" }